// extracted by mini-css-extract-plugin
module.exports = {"form":"search-form_form__aprR_","button":"search-form_button__UR2em"};